import { SubscribersStore } from '../stores/subscribers';
import { setUiStatusesListArray, setUiTotal } from './ui';
import { appConfig } from '../settings';
import { apiManager } from '../REST';
import { IParamsList } from '../interfaces';
import {
    ISubscribersListAPI,
    ISubscribersListItem,
    ISubscribersListItemAPI,
    ISubscribersSelectListAPI,
    ISubscribersSubStatusSelectAPI,
} from '../interfaces';
import { cleanCompaniesStore, cleanOperatorsStore, getCompaniesSelect, getOperatorsSelect } from '../middleware';
import { mapApi2UiField } from '../instruments';

export function setSubscribersSelect(data: ISubscribersSelectListAPI): void {
    const StoreInstance = SubscribersStore.getInstance();
    StoreInstance.setSubscribersSelect(data);
}

export function cleanSubscribersStore(): void {
    const StoreInstance = SubscribersStore.getInstance();
    StoreInstance.cleanStore();
}
export function setSubscribersExternalAPIListFilterParamsStore(): void {
    const StoreInstance = SubscribersStore.getInstance();
    StoreInstance.setExternalAPIListFilterParams();
}

export function setSubscribersList(apiData: ISubscribersListItemAPI[]): void {
    const storeData =
        apiData?.map((item: ISubscribersListItemAPI) => {
            return {
                ...mapApi2UiField(item),
                deviceInfo: mapApi2UiField(item.device_info || {}),
            } as ISubscribersListItem;
        }) || [];
    const StoreInstance = SubscribersStore.getInstance();
    StoreInstance.setSubscribersList(storeData);
}

export async function getSubscribersStatusesSelect(): Promise<void> {
    const { resp } = await apiManager.getApi('GET_SUBSCRIBERS_STATUS_SELECT');
    const response = resp as ISubscribersSubStatusSelectAPI;
    setUiStatusesListArray(response?.statuses);
}

export function getSubscribersRelationSelect(): void {
    getSubscribersStatusesSelect();
    getCompaniesSelect();
    getOperatorsSelect();
}

export function cleanSubscribersRelationSelectAndStore(): void {
    cleanSubscribersStore();
    cleanCompaniesStore();
    cleanOperatorsStore();
}

export function getExternalAPICSubscribersRelationSelect(): void {
    getOperatorsSelect(false, false, undefined, appConfig.externalAPICompanyIds);
}

export async function getSubscribersList(params: IParamsList): Promise<void> {
    const { resp } = await apiManager.getApi('GET_SUBSCRIBERS_LIST_V2', { searchParamsList: params });
    const { meta } = resp;
    const { subscribers } = resp as ISubscribersListAPI;
    meta && setUiTotal(meta.records_count);
    subscribers && setSubscribersList(subscribers);
}

export function setSubscribersForcedUpdateTime(): void {
    const StoreInterface = SubscribersStore.getInstance();
    StoreInterface.setForcedUpdateTime();
}

export async function deleteSubscriber(id: string): Promise<void> {
    const { isError } = await apiManager.getApi('DELETE_SUBSCRIBER_V2', { id });
    if (!isError) {
        setSubscribersForcedUpdateTime();
    }
}
